export enum UserState {
  UNLOADED,
  NOT_AUTHENTICATED,
  SIGNIN,
  SIGNOUT,
}

export interface AuthState {
  authenticated: boolean;
  error?: string;
  status: UserState;
  fetchedLoginGql?: boolean;
  authReady: boolean;
  isOnboarded?: boolean;
  signingIn: boolean;
}

export const initialState: AuthState = {
  status: UserState.UNLOADED,
  authenticated: false,
  fetchedLoginGql: false,
  authReady: false,
  isOnboarded: false,
  signingIn: false,
};

export type RootState = { auth: AuthState };
